import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HubLoAuthorizeResult, IAccount } from '../../hub-lo.component';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { TrackingActions } from '@toro/common/shared/state-management/tracking/tracking.action';
import { ActionEventsEnum } from '@toro/common/shared/enum/tracking/action-events.enum';
import { LoMessages } from '@toro/common/shared/enum/banks/lo-messages.enum';

@Component({
  selector: 'hub-lo-result-step',
  templateUrl: 'result-step.component.html',
  styleUrls: ['result-step.component.scss'],
})
export class HubLoResultStepComponent implements OnInit {
  @Input() public result: HubLoAuthorizeResult = HubLoAuthorizeResult.Success;
  @Input() public origin: 'Home' | 'Dados bancários' = 'Home';
  @Input() public account: IAccount | null = null;

  @Output() public redirect = new EventEmitter<void>();
  @Output() public closeDrawer = new EventEmitter<void>();
  @Output() public back = new EventEmitter<void>();
  @Output() public registerAccount = new EventEmitter<void>();

  public readonly HubLoAuthorizeResult = HubLoAuthorizeResult;
  public readonly loMessages = LoMessages;

  public constructor(private store: Store<AppState>) {}

  public get accountTypeLabel(): string {
    return this.account && this.account.type === 2
      ? 'Conta Poupança Santander'
      : 'Conta Corrente Santander';
  }

  public get accountDetailsLabel(): string {
    if (!this.account) {
      return '';
    }
    const agency = this.account.agency || '';
    const number = this.account.number || '';
    const digit = this.account.digit ? `-${this.account.digit}` : '';
    return `Agência: ${agency} · Conta: ${number}${digit}`;
  }

  public ngOnInit(): void {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.PAGE_LOADED,
        events: {
          'Product Area Origin': this.origin,
          Step: 'Feedback autorizar comunicação entre contas',
          Status: this.resolveStatus(),
          'Time Responsável': 'Sky',
        },
      },
    });
  }

  private resolveStatus(): string {
    switch (this.result) {
      case HubLoAuthorizeResult.OwnershipInvalid:
        return 'Titularidade inválida';
      case HubLoAuthorizeResult.Failure:
        return 'Erro ao processar solicitação';
      case HubLoAuthorizeResult.Success:
      default:
        return 'Cadastro de conta concluído';
    }
  }

  public investRedirect(): void {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.ELEMENT_CLICKED,
        events: {
          'Product Area Origin': this.origin,
          Element: 'Botão Investir',
          Step: 'Feedback autorizar comunicação entre contas',
          Status: 'Cadastro de conta concluído',
          'Time Responsável': 'Sky',
        },
      },
    });
    this.redirect.emit();
  }

  public registerAccountRedirect(): void {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.ELEMENT_CLICKED,
        events: {
          'Product Area Origin': this.origin,
          Element: 'Botão Cadastrar conta',
          Step: 'Feedback autorizar comunicação entre contas',
          Status: 'Titularidade inválida',
          'Time Responsável': 'Sky',
        },
      },
    });
    this.registerAccount.emit();
  }

public closeRedirect(): void {
    this.store.dispatch({
      type: TrackingActions.trackEvents,
      payload: {
        type: ActionEventsEnum.ELEMENT_CLICKED,
        events: {
          'Product Area Origin': this.origin,
          Element: 'Botão Fechar',
          Step: 'Feedback autorizar comunicação entre contas',
          Status: 'Cadastro de conta concluído',
          'Time Responsável': 'Sky',
        },
      },
    });
    this.redirect.emit();
  }
}
